"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutSubscriptionDtoPlanCodeEnum = void 0;
exports.instanceOfCheckoutSubscriptionDto = instanceOfCheckoutSubscriptionDto;
exports.CheckoutSubscriptionDtoFromJSON = CheckoutSubscriptionDtoFromJSON;
exports.CheckoutSubscriptionDtoFromJSONTyped = CheckoutSubscriptionDtoFromJSONTyped;
exports.CheckoutSubscriptionDtoToJSON = CheckoutSubscriptionDtoToJSON;
exports.CheckoutSubscriptionDtoToJSONTyped = CheckoutSubscriptionDtoToJSONTyped;
/**
 * @export
 */
exports.CheckoutSubscriptionDtoPlanCodeEnum = {
    ChampionYearly: 'champion_yearly'
};
/**
 * Check if a given object implements the CheckoutSubscriptionDto interface.
 */
function instanceOfCheckoutSubscriptionDto(value) {
    if (!('planCode' in value) || value['planCode'] === undefined)
        return false;
    return true;
}
function CheckoutSubscriptionDtoFromJSON(json) {
    return CheckoutSubscriptionDtoFromJSONTyped(json, false);
}
function CheckoutSubscriptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'planCode': json['planCode'],
        'selectedSportCodes': json['selectedSportCodes'] == null ? undefined : json['selectedSportCodes'],
        'idempotencyKey': json['idempotencyKey'] == null ? undefined : json['idempotencyKey'],
    };
}
function CheckoutSubscriptionDtoToJSON(json) {
    return CheckoutSubscriptionDtoToJSONTyped(json, false);
}
function CheckoutSubscriptionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'planCode': value['planCode'],
        'selectedSportCodes': value['selectedSportCodes'],
        'idempotencyKey': value['idempotencyKey'],
    };
}
